class RelanceDevisModel {
    constructor(data) {
        this.id = data.id || null;
        this.user_id = data.user_id || null;      // Lien avec l'utilisateur
        this.devis_id = data.devis_id || null;    // Lien avec le devis
        this.date_relance = data.date_relance || null;
        this.subject = data.subject || null;
        this.title = data.title || null;
        this.message = data.message || null;

        // Relations (devis et client)
        this.devis = data.devis || null;   // Détails du devis associé
        this.client = data.client || null; // Détails du client associé au devis

        // Métadonnées
        this.created_at = data.created_at || null;
        this.updated_at = data.updated_at || null;
    }
}

export default RelanceDevisModel;
